import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateListResource } from '../../../lib/query/invalidateResource';
import { deleteOfferingCategory } from '../api/offeringCategories';
import { notification } from 'antd';

export function useDeleteOfferingCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteOfferingCategory(id),
    onSuccess: () => {
      notification.success({ message: 'Category deleted successfully' });
      invalidateListResource(queryClient, 'offering-categories');
    },
    onError: () => {
      notification.error({ message: 'Failed to delete category' });
    },
  });
}
